<template>
    <div class="container mt-4">
        <!-- Swiper Tabs -->
        <div class="col-12">
            <swiper :slides-per-view="3" :space-between="1" :centered-slides="false" :navigation="false"
                :pagination="false" :grab-cursor="true" :breakpoints="{
                    200: { slidesPerView: 3 },
                    400: { slidesPerView: 4 },
                    550: { slidesPerView: 5 },
                    768: { slidesPerView: 6 },
                    1024: { slidesPerView: 8 },
                    1200: { slidesPerView: 8 }
                }">
                <swiper-slide v-for="(tab, index) in tabs" :key="index" class="m-0 p-0">
                    <button type="button" :class="['tab-btn', activeTab === index ? 'active' : '', tabLlena(tab) ? 'llena' : '']" @click="changeTab(index)">
                        <i :class="tab.icon" class="tab-icon"></i>
                        <span>{{ tab.title }}</span>
                    </button>
                </swiper-slide>
            </swiper>
        </div>

        <!-- Contenido dinámico -->
        <div class="mt-3" @input="actualizarEstado" @change="actualizarEstado" @click="actualizarEstado">
            <keep-alive>
                <component :is="tabs[activeTab].component" :ref="setComponentRef" :consulta-lista="consultaLista"
                    @contenido="actualizarEstado" @dando-receta="marcarDandoReceta" @guardar-consulta="finalizar"></component>
            </keep-alive>
        </div>

        <div v-show="mostrarFinalizar">
            <hr>
            <div class="d-flex justify-content-end">
                <button style="background: #0078be!important;" type="submit" class="btn btn-success btn-sm me-2"
                    @click="finalizar">
                    Finalizar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { ref, computed, defineAsyncComponent, markRaw, watch, nextTick } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import { apiInstance1 } from "../../store/axios";
import { limpiarBorrador, leerSeccion, leerDiagnosticos } from "../../utils/atencionBorrador";
import { useRoute, useRouter } from 'vue-router'; // Importamos el hook useRoute


// Importa los componentes dinámicos y márcalos como no reactivos
const SignosVitales = markRaw(defineAsyncComponent(() => import("./resumenSignosVitales.vue")));
const Organos = markRaw(defineAsyncComponent(() => import("./Organos.vue")));
const Antecedentes = markRaw(defineAsyncComponent(() => import("./Antecedentes.vue")));
const Diagnostico = markRaw(defineAsyncComponent(() => import("./Diagnostico.vue")));
const MotivoConsulta = markRaw(defineAsyncComponent(() => import("./MotivoConsulta.vue")));
const Tratamiento = markRaw(defineAsyncComponent(() => import("./Tratamiento.vue")));
const Examenes = markRaw(defineAsyncComponent(() => import("./Examen.vue")));
const Odontologia = markRaw(defineAsyncComponent(() => import("./Odontologia.vue")));
const Estomatognatico = markRaw(defineAsyncComponent(() => import("./Estomatognatico.vue")));
const Receta = markRaw(defineAsyncComponent(() => import("../Receta/Index.vue")));

export default {
    name: "Examenes",
    components: { Swiper, SwiperSlide },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const activeTab = ref(0);
        const componentRefs = ref({}); // Almacena referencias a todos los componentes hijos
        const pestanasLlenas = ref({});
        const dandoReceta = ref(false);
        //const cod_consulta = route.query.cod_consulta;

        const tabs = ref([]);


        const especialidad = localStorage.getItem("userData");
        let result = JSON.parse(especialidad);
        const especialidadUsuario = result.especialidad;

        if (especialidadUsuario === 'ODONTOLOGIA') {
            tabs.value = [
                { title: "Signos Vitales", icon: "fas fa-hospital", component: SignosVitales, clave: "ResumenSignosVitales" },
                { title: "Motivo de consulta", icon: "fas fa-user-md", component: MotivoConsulta, clave: "Motivo-Consulta" },
                { title: "Estomatognático", icon: "fas fa-stethoscope", component: Estomatognatico, clave: "Estomatognatico" },
                { title: "Diagnóstico", icon: "fas fa-heartbeat", component: Diagnostico, clave: "Diagnosticos" },
                { title: "Odontograma", icon: "fas fa-tooth", component: Odontologia, clave: "Odontograma" },
                { title: "Tratamiento", icon: "fa-solid fa-syringe", component: Tratamiento, clave: "Tratamiento" },
                { title: "Receta", icon: "fa-solid fa-prescription-bottle", component: Receta, clave: "Recetas" }
            ];
        } else {
            tabs.value = [
                { title: "Signos Vitales", icon: "fas fa-hospital", component: SignosVitales, clave: "ResumenSignosVitales" },
                { title: "Motivo de consulta", icon: "fas fa-user-md", component: MotivoConsulta, clave: "Motivo-Consulta" },
                { title: "Antecedentes", icon: "fas fa-calendar-alt", component: Antecedentes, clave: "Antecedentes" },
                { title: "Órganos y Físicos", icon: "fas fa-stethoscope", component: Organos, clave: "Organos" },
                { title: "Diagnóstico", icon: "fas fa-heartbeat", component: Diagnostico, clave: "Diagnosticos" },
                { title: "Exámenes", icon: "fas fa-microscope", component: Examenes, clave: "OrdenExamenes" },
                { title: "Tratamiento", icon: "fa-solid fa-syringe", component: Tratamiento, clave: "Tratamiento" },
                { title: "Receta", icon: "fa-solid fa-prescription-bottle", component: Receta, clave: "Recetas" }
            ];
        }

        // Función para asignar referencias a los componentes hijos
        const conTexto = (valor) => String(valor ?? '').trim() !== ''

        const llenaEnBorrador = (clave, codPaciente) => {
            if (clave === 'Diagnosticos') {
                const lista = leerDiagnosticos(codPaciente)
                return lista.length > 0 && lista.every((item) => conTexto(item.tipo))
            }

            if (clave === 'Recetas') {
                const seccion = leerSeccion(codPaciente, 'Recetas')
                return Boolean(seccion && (seccion.noGenerar || seccion.recetaGenerada))
            }

            const datos = leerSeccion(codPaciente, clave)
            if (!datos) return false

            if (clave === 'ResumenSignosVitales') {
                const campos = ['peso', 'talla', 'perimetroAbdominal', 'perimetroCefalico', 'presionSistolica', 'presionDiastolica', 'temperatura', 'frecuenciaCardiaca', 'saturacionOxigeno', 'frecuenciaRespiratoria', 'glucosaCapilar', 'hemoglobina', 'hemoglobinaCorregida']
                return campos.some((campo) => conTexto(datos[campo]))
            }

            if (clave === 'Motivo-Consulta') {
                return conTexto(datos.motivoAtencion) && conTexto(datos.motivoAnamnesis)
            }

            if (clave === 'Estomatognatico') {
                const personales = Array.isArray(datos.antecedentesPersonales) ? datos.antecedentesPersonales : []
                return Boolean(datos.sinPatologiaPersonal) || personales.some((item) => item.checked)
            }

            if (clave === 'Antecedentes') {
                const personales = Array.isArray(datos.antecedentesPersonales) ? datos.antecedentesPersonales : []
                const familiares = Array.isArray(datos.antecedentesFamiliares) ? datos.antecedentesFamiliares : []
                const personal = Boolean(datos.sinPatologiaPersonal) || personales.some((item) => item.checked)
                const familiar = Boolean(datos.sinPatologiaFamiliar) || familiares.some((item) => item.checked)
                return personal && familiar
            }

            if (clave === 'Organos') {
                const revision = Boolean(datos.sinRevision) || (Array.isArray(datos.organosSeleccionados) && datos.organosSeleccionados.length > 0)
                const fisico = Boolean(datos.sinExamenFisico) || (Array.isArray(datos.examenFisicoSeleccionados) && datos.examenFisicoSeleccionados.length > 0)
                return revision && fisico
            }

            if (clave === 'Odontograma') {
                const marcado = (lista) => Array.isArray(lista) && lista.some((diente) => diente.status && Object.keys(diente.status).length > 0)
                return marcado(datos.topTeeth) || marcado(datos.bottomTeeth)
            }

            if (clave === 'OrdenExamenes') {
                const tieneExamenes = Array.isArray(datos.selectedExams) && datos.selectedExams.length > 0
                return Boolean(datos.noGenerarOrden) || tieneExamenes || conTexto(datos.otros)
            }

            if (clave === 'Tratamiento') {
                return conTexto(datos.tratamiento)
            }

            return false
        }

        const actualizarEstado = () => {
            const codPaciente = route.query.cod_paciente
            const siguiente = {}
            tabs.value.forEach((tab) => {
                const instancia = componentRefs.value[tab.clave]
                if (instancia && typeof instancia.estaLlena === 'function') {
                    siguiente[tab.clave] = Boolean(instancia.estaLlena())
                } else {
                    siguiente[tab.clave] = llenaEnBorrador(tab.clave, codPaciente)
                }
            })
            pestanasLlenas.value = siguiente
        }

        const tabLlena = (tab) => Boolean(pestanasLlenas.value[tab.clave])

        const setComponentRef = (el) => {
            if (el) {
                componentRefs.value[el.$options.name] = el; // Usa el nombre del componente como clave
                nextTick(() => actualizarEstado())
            }
        };

        const changeTab = (index) => {
            const codPaciente = route.query.cod_paciente
            const codConsulta = route.query.cod_consulta
            Object.keys(componentRefs.value).forEach((nombre) => {
                const instancia = componentRefs.value[nombre]
                if (instancia && typeof instancia.guardarEnBorrador === 'function') {
                    instancia.guardarEnBorrador(codPaciente, codConsulta)
                }
            })
            activeTab.value = index
            nextTick(() => actualizarEstado())
        };

        const antecedentesDesdeBorrador = (sinPatologia, lista, tipo, claveObservacion, observacion) => {
            if (sinPatologia) {
                return [{
                    tipo,
                    enfermedad: "SIN PATOLOGÍA APARENTE",
                    detalle: "",
                    [claveObservacion]: observacion || ""
                }]
            }
            return (Array.isArray(lista) ? lista : [])
                .filter((item) => item.checked)
                .map((item) => ({
                    tipo,
                    enfermedad: item.label,
                    detalle: item.detail,
                    [claveObservacion]: observacion || ""
                }))
        }

        const datosDesdeBorrador = (codPaciente, codConsulta) => {
            const datos = {}
            const motivo = leerSeccion(codPaciente, 'Motivo-Consulta')
            if (motivo) {
                datos["Motivo-Consulta"] = {
                    motivoAtencion: motivo.motivoAtencion || "",
                    motivoAnamnesis: motivo.motivoAnamnesis || "",
                    cod_consulta: codConsulta
                }
            }

            const estomatognatico = leerSeccion(codPaciente, 'Estomatognatico')
            if (estomatognatico) {
                const personales = antecedentesDesdeBorrador(
                    estomatognatico.sinPatologiaPersonal,
                    estomatognatico.antecedentesPersonales,
                    "Personal",
                    "observacionAntecedentePersonal",
                    estomatognatico.observacionAntecedentePersonal
                )
                datos.Estomatognatico = [
                    ...personales,
                    { tipo: "Familiar", enfermedad: "", detalle: "", observacionAntecedenteFamiliar: "" }
                ]
            }

            const antecedentes = leerSeccion(codPaciente, 'Antecedentes')
            if (antecedentes) {
                datos.Antecedentes = [
                    ...antecedentesDesdeBorrador(
                        antecedentes.sinPatologiaPersonal,
                        antecedentes.antecedentesPersonales,
                        "Personal",
                        "observacionAntecedentePersonal",
                        antecedentes.observacionAntecedentePersonal
                    ),
                    ...antecedentesDesdeBorrador(
                        antecedentes.sinPatologiaFamiliar,
                        antecedentes.antecedentesFamiliares,
                        "Familiar",
                        "observacionAntecedenteFamiliar",
                        antecedentes.observacionAntecedenteFamiliar
                    )
                ]
            }

            const diagnosticos = leerDiagnosticos(codPaciente)
            if (diagnosticos.length) datos.Diagnosticos = diagnosticos

            const tratamiento = leerSeccion(codPaciente, 'Tratamiento')
            if (tratamiento) datos.Tratamiento = tratamiento.tratamiento || ""

            const organos = leerSeccion(codPaciente, 'Organos')
            if (organos) datos.Organos = organos

            const odontograma = leerSeccion(codPaciente, 'Odontograma')
            if (odontograma) datos.Odontograma = odontograma

            const examenes = leerSeccion(codPaciente, 'OrdenExamenes')
            if (examenes) {
                const selectExamenes = (examenes.selectedExams || []).map((item) => {
                    const separador = String(item).indexOf("-")
                    return {
                        categoria: String(item).substring(0, separador),
                        examen: String(item).substring(separador + 1)
                    }
                })
                datos.OrdenExamenes = {
                    generarOrden: !examenes.noGenerarOrden,
                    selectExamenes,
                    otros: examenes.otros || ""
                }
            }

            const receta = leerSeccion(codPaciente, 'Recetas')
            if (receta) datos.Recetas = receta
            return datos
        }

        const finalizar = async () => {


            let preparaDatoSend = {
                codigoConsulta: "",
                motivoConsulta: "",
                Antecedentes: [],
                organosRevision: {},
                estomatognatico: {},
                ordenExamenes: [],
                tratamiento: "",
                diagnostico: []
            };

            const codPaciente = route.query.cod_paciente
            const codConsulta = route.query.cod_consulta
            Object.keys(componentRefs.value).forEach((nombre) => {
                const instancia = componentRefs.value[nombre]
                if (instancia && typeof instancia.guardarEnBorrador === 'function') {
                    instancia.guardarEnBorrador(codPaciente, codConsulta)
                }
            })

            const allData = datosDesdeBorrador(codPaciente, codConsulta)

            const receta = allData.Recetas || leerSeccion(route.query.cod_paciente, 'Recetas')
            if (receta && receta.resetarMedicamentos && !receta.recetaGenerada && !receta.noGenerar) {
                Swal.fire({
                    title: "Oops...",
                    html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">
                        Debe generar la receta antes de guardar la consulta.</p>`,
                    icon: "warning",
                    width: "400px",
                    customClass: {
                        confirmButton: "btn btn-primary",
                        cancelButton: "btn btn-outline-secondary ml-1",
                    },
                    buttonsStyling: false,
                });
                return;
            }



            if (especialidadUsuario === 'ODONTOLOGIA') {

                if (!allData["Motivo-Consulta"] ||
                    !allData["Motivo-Consulta"].motivoAtencion ||
                    !allData["Motivo-Consulta"].motivoAnamnesis ||
                    allData["Motivo-Consulta"].motivoAtencion.trim() === "" ||
                    allData["Motivo-Consulta"].motivoAnamnesis.trim() === "") {
                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">
                        Debe completar el motivo de consulta:<br>
                        - Motivo de Atención<br>
                        - Anamnesis</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                    return;
                }


                // Verificar si existen antecedentes estomatognáticos
                if (!allData?.Estomatognatico || !Array.isArray(allData.Estomatognatico) || allData.Estomatognatico.length === 0) {
                    Swal.fire({
                        title: "Error en los datos",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">
                Debe haber al menos un antecedente <b>Estomatognático.</b></p>`,
                        icon: "error",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                    return; // Detener la ejecución si no se cumple la validación
                }

                // Verificar si hay al menos un antecedente personal con enfermedad y el familiar
                const tieneEstomatognatico = allData.Estomatognatico.some(a => 
                    a.tipo === "Personal" && 
                    (a.enfermedad?.trim() !== "" || a.enfermedad === "SIN PATOLOGÍA APARENTE")
                );

                const tieneFamiliar = allData.Estomatognatico.some(a => a.tipo === "Familiar");

                if (!tieneEstomatognatico || !tieneFamiliar) {
                    Swal.fire({
                        title: "Error en los datos",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">
                Debe haber al menos un antecedente <b>Estomatognático</b> o marcar la opción "Sin Patología", y el antecedente familiar.</p>`,
                        icon: "error",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                    return; // Detener la ejecución si no se cumple la validación
                }



                // Verificar si allData o allData.Diagnosticos es undefined o vacío
                if (!allData?.Diagnosticos || !Array.isArray(allData.Diagnosticos) || allData.Diagnosticos.length === 0) {
                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">No hay diagnósticos disponibles.</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return; // Detener la ejecución si no hay datos
                }

                // Validar que todos los diagnósticos tengan un tipo válido
                const diagnosticosInvalidos = allData.Diagnosticos.filter(d => !d.tipo || d.tipo.trim() === "");

                if (diagnosticosInvalidos.length > 0) {
                    Swal.fire({
                        title: "Error en los diagnósticos",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">
                Todos los diagnósticos deben tener un <b>tipo</b> definido.</p>`,
                        icon: "error",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return; // Detener la ejecución si hay diagnósticos sin tipo
                }


               


                 // Llamar al método agruparPorTipo
                 const datosAgrupados = agruparPorTipo(allData.Estomatognatico);


                if (!allData?.Tratamiento || allData.Tratamiento.trim() === "") {

                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">El tratamiento está vacio.</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return
                }

                // Validar que el odontograma tenga la estructura correcta y al menos un diente con estado
                if (!allData?.Odontograma || 
                    !allData.Odontograma.topTeeth || 
                    !allData.Odontograma.bottomTeeth || 
                    !allData.Odontograma.topTeeth.some(tooth => Object.keys(tooth.status).length > 0) && 
                    !allData.Odontograma.bottomTeeth.some(tooth => Object.keys(tooth.status).length > 0)) {
                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">El odontograma está vacío.</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return
                }


                //pongo por defecto ciertos datos por que el odontologo no necesita llenar los otros

                preparaDatoSend = {
                    codigoConsulta: allData["Motivo-Consulta"].cod_consulta,
                    motivoConsulta: allData["Motivo-Consulta"],
                    Antecedentes: datosAgrupados,
                    organosRevision: {
                        "organosSeleccionados": [],
                        "observaciones": "",
                        "sinRevision": true,
                        "examenFisicoSeleccionados": [],
                        "observacionesExamenFisico": "",
                        "sinExamenFisico": true
                    },
                    ordenExamenes: {
                        "generarOrden": false,
                        "selectExamenes": [],
                        "otros": ""
                    },
                    tratamiento: allData?.Tratamiento,
                    diagnostico: allData?.Diagnosticos,
                    odontograma: allData?.Odontograma
                };

                console.log('Todos los datos:', preparaDatoSend);


                try {

                    Swal.fire({
                        html:
                            '<div class="row"><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div><div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"><div class="loader"> </div></div><div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><p style="margin:0px; font-size:16px; text-align:center; font-weight:bold">Registrando, espere...</p></div><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div></div>',
                        showCloseButton: false,
                        showCancelButton: false,
                        focusConfirm: false,
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        position: 'center',
                    });


                    const response = await apiInstance1.post("/consulta/getSavedDiagnosticos", { preparaDatoSend }, {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": '',
                        }
                    })

                    if (response.data.code === 200) {
                        Swal.fire({
                            title: "Atención Médica",
                            text: "Registrado con éxito.",
                            icon: "success",
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            customClass: {
                                confirmButton: "btn btn-primary"
                            },
                            buttonsStyling: false,
                        }).then(() => {
                            // Recargar la página después de aceptar el mensaje
                            //
                            //window.location.reload();
                            limpiarBorrador();
                            router.push("/dashboard/atenciones");



                        });

                        return
                    }

                    Swal.fire({
                        title: "Error",
                        text: response.data?.message || "Ocurrió un problema al registrar.",
                        icon: "error",
                        confirmButtonText: "Aceptar",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        customClass: {
                            confirmButton: "btn btn-danger"
                        },
                        buttonsStyling: false
                    });

                } catch (error) {
                    Swal.fire({
                        title: "Error",
                        text: error?.response?.data?.message || "Ocurrió un problema al registrar.",
                        icon: "error",
                        confirmButtonText: "Aceptar",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        customClass: {
                            confirmButton: "btn btn-danger"
                        },
                        buttonsStyling: false
                    });
                }















            } else {







                /* console.log('Prueba codigo consulta')
                console.log(allData["Motivo-Consulta"].cod_consulta)
                return */

                if (!allData["Motivo-Consulta"] ||
                    !allData["Motivo-Consulta"].motivoAtencion ||
                    !allData["Motivo-Consulta"].motivoAnamnesis ||
                    allData["Motivo-Consulta"].motivoAtencion.trim() === "" ||
                    allData["Motivo-Consulta"].motivoAnamnesis.trim() === "") {
                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">
                        Debe completar el motivo de consulta:<br>
                        - Motivo de Atención<br>
                        - Anamnesis</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                    return;
                }


                // Validar si los antecedentes están vacíos
                if (!allData.Antecedentes || allData.Antecedentes.length === 0) {
                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">No hay datos de antecedentes para procesar.</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                    return; // Detener la ejecución si no hay datos
                }

                // Verificar si existen antecedentes de tipo "Personal" y "Familiar"
                const tienePersonal = allData.Antecedentes.some(a => a.tipo === "Personal" && a.enfermedad?.trim() !== "");
                const tieneFamiliar = allData.Antecedentes.some(a => a.tipo === "Familiar" && a.enfermedad?.trim() !== "");

                if (!tienePersonal || !tieneFamiliar) {
                    Swal.fire({
                        title: "Error en los datos",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">
                Debe haber al menos un antecedente <b>Personal</b> y uno <b>Familiar</b> con enfermedad registrada.</p>`,
                        icon: "error",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                    return; // Detener la ejecución si no se cumple la validación
                }




                // Verificar si allData o allData.Organos es undefined
                if (!allData?.Organos) {
                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">No hay datos de revisión de Órganos disponibles.</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return; // Detener ejecución
                }

                // Validar si falta la revisión de Órganos o el Examen Físico
                if (
                    (!allData.Organos.sinRevision && (!allData.Organos.organosSeleccionados || allData.Organos.organosSeleccionados.length === 0)) ||
                    (!allData.Organos.sinExamenFisico && (!allData.Organos.examenFisicoSeleccionados || allData.Organos.examenFisicoSeleccionados.length === 0))
                ) {
                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">Complete la revisión de Órganos y Físicos.</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return; // Detener la ejecución
                }


                // Llamar al método agruparPorTipo
                const datosAgrupados = agruparPorTipo(allData.Antecedentes);



                // Verificar si allData o allData.Diagnosticos es undefined o vacío
                if (!allData?.Diagnosticos || !Array.isArray(allData.Diagnosticos) || allData.Diagnosticos.length === 0) {
                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">No hay diagnósticos disponibles.</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return; // Detener la ejecución si no hay datos
                }

                // Validar que todos los diagnósticos tengan un tipo válido
                const diagnosticosInvalidos = allData.Diagnosticos.filter(d => !d.tipo || d.tipo.trim() === "");

                if (diagnosticosInvalidos.length > 0) {
                    Swal.fire({
                        title: "Error en los diagnósticos",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">
                Todos los diagnósticos deben tener un <b>tipo</b> definido.</p>`,
                        icon: "error",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return; // Detener la ejecución si hay diagnósticos sin tipo
                }



                // Verificar si allData o allData.OrdenExamenes es undefined
                if (!allData?.OrdenExamenes) {
                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">No hay datos de Orden de Exámenes disponibles.</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return; // Detener la ejecución si OrdenExamenes es undefined
                }

                // Extraer datos para facilitar la lectura
                const { generarOrden, selectExamenes, otros } = allData.OrdenExamenes;

                // Si generarOrden es false, dejar pasar
                if (generarOrden) {

                    // Verificar si selectExamenes tiene datos o si otros no está vacío
                    const tieneExamenes = Array.isArray(selectExamenes) && selectExamenes.length > 0;
                    const tieneOtros = typeof otros === "string" && otros.trim().length > 0;

                    if (!tieneExamenes && !tieneOtros) {
                        Swal.fire({
                            title: "Oops...",
                            html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">
                Debe seleccionar al menos un examen o ingresar otro.</p>`,
                            icon: "warning",
                            width: "400px",
                            customClass: {
                                confirmButton: "btn btn-primary",
                                cancelButton: "btn btn-outline-secondary ml-1",
                            },
                            buttonsStyling: false,
                        });

                        return; // Detener la ejecución si no cumple con la validación
                    }

                }




                if (!allData?.Tratamiento || allData.Tratamiento.trim() === "") {

                    Swal.fire({
                        title: "Oops...",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">El tratamiento está vacio.</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });

                    return
                }

                preparaDatoSend = {
                    codigoConsulta: allData["Motivo-Consulta"].cod_consulta,
                    motivoConsulta: allData["Motivo-Consulta"],
                    Antecedentes: datosAgrupados,
                    organosRevision: allData?.Organos,
                    ordenExamenes: allData?.OrdenExamenes,
                    tratamiento: allData?.Tratamiento,
                    diagnostico: allData?.Diagnosticos
                };


                try {

                    Swal.fire({
                        html:
                            '<div class="row"><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div><div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"><div class="loader"> </div></div><div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><p style="margin:0px; font-size:16px; text-align:center; font-weight:bold">Registrando, espere...</p></div><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div></div>',
                        showCloseButton: false,
                        showCancelButton: false,
                        focusConfirm: false,
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        position: 'center',
                    });

                    const response = await apiInstance1.post("/consulta/getSavedDiagnosticos", { preparaDatoSend }, {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": '',
                        }
                    })

                    if (response.data.code === 200) {
                        Swal.fire({
                            title: "Atención Médica",
                            text: "Registrado con éxito.",
                            icon: "success",
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            customClass: {
                                confirmButton: "btn btn-primary"
                            },
                            buttonsStyling: false,
                        }).then(() => {
                            // Recargar la página después de aceptar el mensaje
                            //
                            //window.location.reload();
                            limpiarBorrador();
                            router.push("/dashboard/atenciones");



                        });

                        return
                    }

                    Swal.fire({
                        title: "Error",
                        text: response.data?.message || "Ocurrió un problema al registrar.",
                        icon: "error",
                        confirmButtonText: "Aceptar",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        customClass: {
                            confirmButton: "btn btn-danger"
                        },
                        buttonsStyling: false
                    });

                } catch (error) {
                    Swal.fire({
                        title: "Error",
                        text: error?.response?.data?.message || "Ocurrió un problema al registrar.",
                        icon: "error",
                        confirmButtonText: "Aceptar",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        customClass: {
                            confirmButton: "btn btn-danger"
                        },
                        buttonsStyling: false
                    });
                }








            }



        };

        // Función para agrupar datos por tipo
        const agruparPorTipo = (datos) => {
            // Si datos es undefined o no es un array, retornar un objeto vacío
            if (!datos || !Array.isArray(datos)) {
                return {
                    tipoPersonal: { items: [], observacion: "" },
                    tipoFamiliar: { items: [], observacion: "" }
                };
            }

            const resultado = {};

            datos.forEach(item => {
                const tipo = item.tipo.toLowerCase(); // Convertir a minúsculas
                const clave = `tipo${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`; // Crear clave dinámica (tipoPersonal, tipoFamiliar)

                if (!resultado[clave]) {
                    resultado[clave] = {
                        items: [], // Array para almacenar los elementos del tipo
                        observacion: item[`observacionAntecedente${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`] // Observación única
                    };
                }

                // Crear un nuevo objeto sin la observación
                const nuevoItem = {
                    enfermedad: item.enfermedad,
                    detalle: item.detalle
                };

                // Agregar el nuevo objeto al array correspondiente
                resultado[clave].items.push(nuevoItem);
            });

            return resultado;
        };


        //Reiniciar componentes

        watch(() => route.query.cod_paciente, () => {
            activeTab.value = 0;
            pestanasLlenas.value = {};
            dandoReceta.value = false;
            nextTick(() => actualizarEstado());
        });

        const consultaLista = computed(() => tabs.value
            .filter((tab) => tab.clave !== 'Recetas')
            .every((tab) => Boolean(pestanasLlenas.value[tab.clave])))

        const mostrarFinalizar = computed(() => {
            const tab = tabs.value[activeTab.value]
            return Boolean(tab && tab.clave === 'Recetas' && !dandoReceta.value)
        })

        const marcarDandoReceta = (valor) => {
            dandoReceta.value = Boolean(valor)
        }

        nextTick(() => actualizarEstado());

        return { activeTab, tabs, changeTab, setComponentRef, finalizar, tabLlena, actualizarEstado, consultaLista, mostrarFinalizar, marcarDandoReceta };
    },

    mounted() {
        const pacienteId = this.$route.params.id; // Accedes al parámetro "id"
    },


};
</script>

<style scoped>
/* Ajustes para los tabs */
.tab-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 10px;
    line-height: 1.15;
    padding: 3px 2px;
    width: 100%;
    height: 46px;
    border: 1px solid #ccc;
    background: white;
    color: #333;
    cursor: pointer;
}

.tab-btn span {
    display: block;
    max-width: 100%;
}

.tab-icon {
    font-size: 14px;
    margin-bottom: 2px;
}

.tab-btn.llena {
    background: #e4e4e4;
    color: #666;
    border-color: #c8c8c8;
}

.tab-btn.active {
    background-color: #0078be;
    color: white;
    border-color: #0078be;
}

.tab-btn.llena.active {
    background-color: #6c757d;
    color: white;
    border-color: #6c757d;
}
</style>